// Chat 模块常量配置
export const CHAT_CONSTANTS = {
  // 消息限制
  MAX_MESSAGE_LENGTH: 500,
  MAX_MESSAGES_PER_LOAD: 100,
  
  // 消息类型
  MESSAGE_TYPES: {
    TEXT: 'text' as const,
    IMAGE: 'image' as const,
    SYSTEM: 'system' as const,
  },
  
  // Realtime 配置
  REALTIME: {
    CHANNEL_PREFIX: 'room:',
    EVENTS: {
      POSTGRES_CHANGES: 'postgres_changes',
    },
    TABLE: 'group_messages',
  },
  
  // 时间格式
  TIME_FORMAT: {
    MESSAGE_TIME: { hour: '2-digit', minute: '2-digit' } as const,
    MESSAGE_DATE: { month: 'long', day: 'numeric' } as const,
  },
  
  // UI 配置
  UI: {
    MESSAGE_BUBBLE_MAX_WIDTH: '80%',
    INPUT_MAX_HEIGHT: 100,
    SCROLL_DELAY: 100,
  },
} as const;

// 消息状态
export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  FAILED: 'failed',
  RECEIVED: 'received',
} as const;

export type MessageStatus = typeof MESSAGE_STATUS[keyof typeof MESSAGE_STATUS];
